import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class OrganismsArchiveListComponent extends Component {
  @action
  hasArchives(items) {
    return items.filter((item) => item.archived === true).length !== 0;
  }
}
